import { render, staticRenderFns } from "./VListItemTitleWrapper.vue?vue&type=template&id=35304786"
import script from "./VListItemTitleWrapper.vue?vue&type=script&lang=js"
export * from "./VListItemTitleWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports